import toast from './toast.vue'

var toastPlugin = {}

toastPlugin.install = function (Vue, options = {}) {
    const ToastController = Vue.extend(toast)

    var instance = new ToastController().$mount(document.createElement('div'));
    document.body.appendChild(instance.$el)

    ToastController.prototype.close = function () {
        this.visiable = false
    }

    Vue.prototype.$toast = (option = {}) => {
        let duration = option.duration || options.duration || 2500
        instance.message = typeof option === 'string' ? option : option.message
        instance.fadeInTop = !!option.fadeInTop

        instance.visiable = true
        instance.theme = option.theme || 'primary'

        setTimeout(function () {
            instance.close()
        }, duration)
    }
}

export default toastPlugin



// WEBPACK FOOTER //
// ./src/components/toast/index.js